let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dl28b")).then(() => parcelRequire('2ORoU'));